export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10815.1240e207.jpg";